define.alias("shared/components/shared/page-picker-legacy", "settings/components/shared/page-picker-legacy");